<template>
    <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '营销数据管理')[0].value">
      <div style="width: 90%;margin-top: 2%;" >
        <div style="height: 95%;">
        <el-form label-width="1%"
                prop="name"
                model="Search">
          <el-form-item>
            <label>行业类型：</label>
            <el-select placeholder="请选择行业类型"
                      size="medium"
                      clearable
                      filterable
                      v-model="Search.industryId"
                      value-key="id"
                      class="banji">
              <el-option v-for="item in ExhibitionIndustryList"
                        :key="item.Id"
                        :label="item.name"
                        :value="item.id"></el-option>
            </el-select>
            <el-button type="primary" style="margin-left: 10px;"
                      @click="search">搜索</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="
            EnterpriseTypeList"
                  empty-text="暂无数据"
                  v-loading="loading" style="width: 100%;height: 85%;">
          <el-table-column prop="name"
                          label="类型名"
                          align="center">
          </el-table-column>
          <el-table-column prop="faucetCompany"
                          label="龙头企业数量"
                          align="center">
          </el-table-column>
          <el-table-column prop="largeCompany"
                          label="大型企业数量"
                          align="center" > 
          </el-table-column>
          <el-table-column prop="mediumSizedCompany"
                          label="中型企业数量"
                          align="center" >
          </el-table-column>
          <el-table-column prop="smallCompany"
                          label="小型企业数量"
                          align="center" >
          </el-table-column>
          <el-table-column prop="cost"
                          label="价格"
                          align="center">
            <template #default="scope">
              <span>{{String(scope.row.cost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="state"
                          label="操作"
                          align="center"
                          fixed="right"
                          width="200px">
            <template #default="scope">
              <el-button size="large"
                        type="primary"
                        @click="management(scope.$index, scope.row)" v-if="scope.row.state == Global.SModel.Delete">
                        {{scope.row.state== Global.SModel.Delete?"购买":"取消"}}
              </el-button>
              <el-button size="large"
                        v-if="scope.row.state== Global.SModel.Create"
                        type="primary"
                        @click="Check(scope.$index, scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChangeType"
                      @current-change="handleCurrentChangeType"
                      :current-page="currentPage"
                      :page-sizes="[5, 10, 15, 20]"
                      :page-size="pagesize"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="EnterpriseTypeTotal"
                      style="display: flex; justify-content: center; margin-top: 10px">
        </el-pagination>
      </div>
    </div>
  </ShowControl>
</template>

<script>
import emitter from '../../../unit/bus'
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  components: {
    ShowControl
  },
  data () {
    return {
      flowID: localStorage.getItem("flowID"),
      EnterpriseTypeList: [],
      EnterpriseTypeTotal: 0,
      currentPage: 1,
      pagesize: 5,
      EnterpriseList: [],
      EnterpriseTotal: '',
      loading: false,
      EnterpriseTypeId: 0,
      loadings: false,
      CompanyInput:
      {
        CompanyTypeId: "",
        CurrentPage: 1,
        Pagesize: 10,
        Query: ""
      },
      CompanyTypeInput:
      {
        round: null,
        currentPage: 1,
        pagesize: 5,
        companyIds: ""
      },
      Search:
      {
        industryId:null
      },
      ExhibitionIndustryList:[],
      MarketReportShow:true,
      childTitle: '',
      title: '营销数据管理',
    }
  },
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
    this.GetEnterpriseTypeList();
    this.GetExhibitionIndustry();
  },
  mounted(){
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/DataAnalysis")
    },
    search()
    {
      this.GetEnterpriseTypeList();
    },
    GetExhibitionIndustry () {
      this.$http.get('ExhibitionIndustry/GetModel').then((res) => {
        if (res.success) {
          this.ExhibitionIndustryList = res.dynamicObj
        } else {
          return this.$message.error(res.message)
        }
      })
    },
    GetEnterpriseTypeList () {
      this.loading = true
      this.CompanyTypeInput.round=this.Round
      this.CompanyTypeInput.currentPage=this.currentPage
      this.CompanyTypeInput.pagesize=this.pagesize
      this.CompanyTypeInput.companyIds=""
      var industry=this.ExhibitionIndustryList.filter(c=>c.id==this.Search.industryId);
      if(industry.length>0)
      {
        this.CompanyTypeInput.companyIds=industry[0].companyTypeIDs;
      }
      this.$http.post(`Company/GetEnterpriseTypeList`,this.CompanyTypeInput).then((res) => {
        if (res.success) {
          this.EnterpriseTypeList = res.dynamicObj
          this.EnterpriseTypeTotal = res.totalRecord;
          this.loading = false
          emitter.emit("Purchase", res.dynamicObj)
        } else {
          return this.$message.error(res.message)
        }
      })
    },
    handleSizeChangeType: function (size) {
      this.pagesize = size;
      this.GetEnterpriseTypeList();
    },
    //当前页码
    handleCurrentChangeType: function (currentPage) {
      this.currentPage = currentPage;
      this.GetEnterpriseTypeList();
    },
    management (index, row) {
      if (this.flowID != this.Global.FlowList.招商) {
        this.$message.error("当前流程阶段不是招商，无法进行操作！");
        return;
      }
      this.loading = true;
      if (row.state == this.Global.SModel.Delete) {
        if (!this.Global.GetBudget(row.cost)) {
          this.$message.error("资金不足");
          this.loading = false;
          return;
        }
        let list = [{
          EnterpriseTypeID: row.id,
          uuid: row.uuid == null ? this.uuid.guid() : row.uuid,
          Cost: row.cost,
          state: this.Global.SModel.Create,
          sTTime: this.filter.formatDate(new Date()), groupId: this.Global.groupid,
          round: this.Round,
          type: "S_PurchaseEnterpriseType",
        }];
        this.$http.post("SModel/PushStrategy", this.Global.getsmodel(list)).then((res) => {
          if (res.success) {
            // this.Global.GetBudget(row.cost);
            this.Global.sendmsgmd(
              "数据分析部门",
              `购买了${row.name}数据，花费了${row.cost}元`,
              1
            );
            var incomet = [{
              buissType: this.Global.PayType.企业数据费,
              buissValue: row.cost,
              name: '企业数据费',
              describe: '',
              round: this.Round,
              buissId: row.id
            }];
            this.API.pushIncomet(incomet, 0);
            this.GetEnterpriseTypeList()
            this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.营销数据管理, buissId : row.id   });  
            this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.normal,'营销数据管理');
          } else {
            this.loading = false
            return this.$message.error(res.message)
          }
        })
      } else {
        let list = [{
          EnterpriseTypeID: row.id,
          uuid: row.uuid == null ? this.uuid.guid() : row.uuid,
          Cost: row.cost,
          state: this.Global.SModel.Delete,
          sTTime: this.filter.formatDate(new Date()),
          groupId: this.Global.groupid,
          round: this.Round,
          type: "S_PurchaseEnterpriseType",
        }];
        this.$http.post("SModel/PushStrategy", this.Global.getsmodel(list)).then((res) => {
          if (res.success) {
            this.Global.GetBudget(-row.cost);
            this.Global.sendmsgmd(
              "数据分析部门",
              `取消购买${row.name}数据，增加了${row.cost}元`,
              1
            );
            var incomet = [{
              buissType: this.Global.PayType.企业数据费,
              round: this.Round,
              buissId: row.id
            }];
            this.API.pushIncomet(incomet, 1);
            this.GetEnterpriseTypeList()
            this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.delete,'营销数据管理');
          } else {
            this.loading = false
            return this.$message.error(res.message)
          }
        })
      }
    },
    Check (index, row) {
      this.$router.push({path:'MarketingDataDetailCard',query:{ id : row.id }})
    }
  }
}
</script>